import type {
  DefaultQueryError,
  EstimateNewOrderRequestBody,
  EstimateNewOrderResponse,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { estimatedFeePartnerFn } from './estimated-fee-partner-fn';
import { ESTIMATE_FEE_ACCEPTS_VERSION } from '@/lib/constants';

export const useEstimatedFeePartner = (
  opts?: UseMutationOptions<
    EstimateNewOrderResponse,
    DefaultQueryError,
    EstimateNewOrderRequestBody
  >
) =>
  useMutation<
    EstimateNewOrderResponse,
    DefaultQueryError,
    EstimateNewOrderRequestBody
  >({
    mutationKey: ['estimatedFeePartnerFn'],
    mutationFn: (body) =>
      estimatedFeePartnerFn(body, {
        headers: { 'accepts-version': ESTIMATE_FEE_ACCEPTS_VERSION },
      }),
    ...opts,
  });
